const tokenKey = 'fudan_keti_token'

import './storage'

export function getToken() {
  return localStorage.getExpire(tokenKey)
}

export function setToken(Token) {
  return localStorage.setExpire(tokenKey, Token , 24*60*60*1000)
  // return localStorage.setExpire(tokenKey, Token , 5000)
}

export function removeToken() {
  return localStorage.removeItem(tokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/token.js